/* eslint-disable */
export default {
  'ko-KR': {
    common: {
      NAME_HOLDER: "이름 *",
      LAST_NAME_HOLDER: "성 *",
      EMAIL_HOLDER: "이메일 주소 *",
      PASS_HOLDER: "비밀번호 *",
      REPEAT_PASS_HOLDER: "비밀번호  재확인 *",
      BUTTON_EMAIL_SIGN_UP: "이메일로 로그인하기",

      TERM_OF_USE: "타임아웃 이용 약관, 뉴스레터 수신에 동의합니다",

      TERMS_AND_CONDITIONS: "이용 약관",
      PRIVACY_POLICY: "개인 정보 정책",

      NEWSLETTER_CONSENT: "최신 뉴스, 이벤트 및 쿠폰에 대한 Time Out 의 이메일 수신에 동의합니다",
      TERM_OF_USE: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "본인은 Time Out 의 약관 및 개인 정보 취급 방침을 읽고 동의하며 뉴스 레터 수신 동의를 포함합니다",

      HEADER_TITLE: "타임아웃 계정을 생성하세요!",
      JOIN_FB: "페이스북으로 가입하기",
      JOIN_TW: "트위터로 가입하기",
      JOIN_GG: "구글로 가입하기",
      JOIN_EM: "이메일로 가입하기",
      ALREADY_HAVE: "타임아웃 계정이 있으신가요?",
      CREATE_ACCOUNT_LOG_IN: "로그인",

      SIGN_IN_TITLE: "로그인",
      SIGN_IN_FB: "페이스북 계정으로 로그인",
      SIGN_IN_TW: "트위터 계정으로 로그인",
      SIGN_IN_GG: "구글 계정으로 로그인",
      SIGN_IN_EM: "이메일로 로그인",
      YOUR_EMAIL: "이메일 주소",
      YOUR_PASSWORD: "비밀번호",
      REMEMBER: "기억합니다",
      FORGOT: "잊어버렸나요?",
      HAVE_ACCOUNT_YET: "아직 타임아웃 계정이 없으신가요?",
      JOIN_HERE: "여기서 가입하세요",
      ALMOST_THERE: "거의 다 왔어",

      FORGOT_HEADER: "비밀번호를 잊으셨나요?",
      FORGOT_SUBTITLE: "아래 이메일 주소를 넣어주세요. 새로운 비밀번호를 설정할 링크를 보내드리겠습니다.",
      SEND_LINK: "링크 보내기",

      RECEIVE_EMAIL: "감사합니다. 이메일이 곧 도착합니다.",
      MANAGE_ACCOUNT: "계정 관리",
      EDIT_DETAILS_HERE: "여기서 당신의 계정을 수정할 수 있습니다",
      FIRST_NAME: "이름",
      LAST_NAME: "성",
      SCREEN_NAME: "닉네임",
      EMAIL: "이메일 주소",
      ACCOUNT_DETAILS: "계정 정보",
      PASSWORD: "비밀번호",
      SAVE_CHANGES: "저장하세요",
      UPLOAD_PIC: "새 프로필 사진을 등록하세요",
      CHOOSE_PHOTO: "사진을 선택하세요(최대 2MB).",
      CLOSE_ACCOUNT: "계정 닫기",
      PASSWORD_BELOW: "아래에서 비밀번호를 변경하세요",
      CURRENT_PASSWORD: "현재 비밀번호",
      NEW_PASSWORD: "새 비밀번호",
      REPEAT_PASSWORD: "새 비밀번호 재확인",

      OOPS: "어머나!",
      ERROR_404_OCCURED: "오류가 발생했습니다.",
      ERROR_404_INFO: "페이지가 바뀌었거나 더 이상 존재하지 않습니다",
      ERROR_500_TITLE: "서버에 문제가 생겼습니다",
      SMTH_BROKEN: "오류",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "오류가 발생했을 때 무엇을 하고 있었는지 알려주세요. 빠른 시일 내에 수정하겠습니다. 불편을 드려 죄송합니다.",
      ERROR_500_INFO: "오류가 발생했을 때 무엇을 하고 있었는지 알려주세요. 빠른 시일 내에 수정하겠습니다. 불편을 드려 죄송합니다.",

      EMAIL_ERROR: "유용한 이메일 주소를 넣으세요",
      PASSWORD_ERROR: "비밀번호를 입력하세요",
      FIRST_NAME_ERROR: "당신의 이름을 입력하세요",
      LAST_NAME_ERROR: "성을 입력하십시오",
      TERM_OF_USE_ERROR: "이용 약관에 동의해야합니다",
      SIGN_IN_VALIDATION_ERROR: "이메일 또는 비밀번호가 정확하지 않습니다. 다시 시도해주세요.",
      ACCOUNT_PASSWORDS_VALIDATION: "비밀번호가 맞지 않습니다",
      WAS_IT: "뭔가 잘못되었나요?",
      DELETE_ACCOUNT_TEXT: "정말 계정을 삭제하시겠습니까? 삭제하려는 가장 큰 이유는 무엇입니까",
      DELETE_ACCOUNT: "계정 삭제",
      CANCEL: "취소",

      UPDATE_PASSWORD: "パスワードを更新する",
      PASSWORD_UPDATE_SUCCESS: "비밀번호가 업데이트되었습니다",
      ERROR_PASSWORD_LENGTH: "비밀번호는 6 자 이상이어야합니다",

      ERROR_MISSING_SITE_PARAMETER: "필수 응용 프로그램 매개 변수 누락 : site",
      ERROR_ALREADY_REGISTERED: "이미 이메일 가입을 사용하여 등록했습니다. {{email}}을 사용하여 로그인하십시오",
    },
    'kr-seoul': {
        TERM_OF_USE: '<a class="xs-text-red cursor-pointer" href="https://www.timeoutkorea.kr/seoul/ko/privacy-policy" target="_blank">' +
      '타임아웃 이용 약관, 뉴스레터 수신에 동의합니다.</a>'

    }
  }
}



// WEBPACK FOOTER //
// ./translations/ko-KR.js